




















































import {
  Vue, Prop, Component, Emit,
} from 'vue-property-decorator';
import TaskService from '@/domain/task/task.service';
import ModalComponent from '@/shared/modal/modal.component.vue';
import ModalOptions from '@/shared/modal/modal-options.entity';
import ContractFilter from '@/domain/contract/entity/contract-filter.entity';
import BillingContractsSelected from '@/domain/billing/entity/billing-contract-selected.entity'
import { BillingDailyFilterType } from '@/domain/contract/entity/billing-daily-filter-type.enum';
import Pagination from '@/domain/pagination.entity';
import DateFormat from '@/shared/utils/date-format';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { BillingType } from '@/shared/utils/billing-type.enum';
import getPastMonth from '@/shared/utils/get-past-month';
import PerformBillingModalFields from '@/views/contract/contract-info/itens/perform-billing/perform-billing-modal-fields.component.vue';
import ContractService from '@/domain/contract/service/contract.service';
import BillingModalPushOrderRequest from '../contract-info/billing-modal-push-order-request.component.vue';
import BillingService from '../../../domain/billing/service/billing.service';

@Component({
  components: {
    ModalComponent,
    PerformBillingModalFields,
    BillingModalPushOrderRequest,
  },
})
export default class ContractBillingModalExecute extends Vue {
  @Prop({
    required: true,
  })
  showModal!: boolean;

  @Prop({
    required: true,
  })
  businessUnitId!: string;

  @Prop({
    required: false,
  })
  contractsFilter!: ContractFilter;

  @Prop({
    required: false,
  })
  enabledOnlyFiltered!: boolean;

  @Prop({ type: Boolean, default: false })
  billingDaily!: boolean;

  competences: string[] = [];

  invoiceCompetence: string = '';

  pickerMenu: boolean = false;

  loading: boolean = false;

  executionId: string = '';

  onlyFiltered: boolean = false;

  onlyFilteredModal: boolean = false;

  billingType: string = BillingType.SINGLE;

  billingContractsSelected!: BillingContractsSelected;

  startDate: string = '';

  endDate: string = '';

  showModalPushOrderPendence: boolean = false;

  pushOrderPendence: number = 0;

  created() {
    this.setPastMonthCompetence();
  }

  get modalState() {
    return this.showModal;
  }

  set modalState(value: boolean) {
    this.$emit('updateModalState', value);
  }

  setPastMonthCompetence(): void {
    this.invoiceCompetence = getPastMonth();
  }

  startLoading(): void {
    this.loading = true;
  }

  stopLoading(): void {
    this.loading = false;
  }

  @Emit('filterContractByCompetence')
  filterContractByCompetence(): string {
    return DateFormat.localDateToLocal(this.invoiceCompetence);
  }

  executeBillingHandler(): void {
    const { form }: any = this.$refs;
    if (!form.validate()) return;

    this.startLoading();

    if (this.onlyFiltered && this.isSingle) {
      this.executeBillingWithFilter(this.contractsFilter);
      return;
    }

    if (this.isSingle && !this.onlyFiltered) {
      this.executeBilling();
      return;
    }

    if (!this.isSingle && this.onlyFiltered) {
      this.executeRetroactiveBillingWithFilter();
      return;
    }

    this.executeRetroactiveBilling();
  }

  async handlerBilling(): Promise<void> {
    const { form }: any = this.$refs;
    if (!form.validate()) return;

    this.startLoading();

    if (this.onlyFiltered && this.isSingle) {
      this.billingDaily = false;
      this.contractsFilter.billingDaily = BillingDailyFilterType.BILLING_COMPETENCE;
      if (await this.checkHasPushOrderPendencesWithFilter(this.contractsFilter)) {
        this.showModalPushOrderPendence = true;
        return;
      }
      this.executeBillingWithFilter(this.contractsFilter);
      return;
    }

    if (this.isSingle && !this.onlyFiltered) {
      if (await this.checkHasPushOrderPendences()) {
        this.showModalPushOrderPendence = true;
        return;
      }
      this.executeBilling();
      return;
    }

    if (!this.isSingle && this.onlyFiltered) {
      if (await this.checkHasPushOrderPendencesWithFilter(this.contractsFilter)) {
        this.showModalPushOrderPendence = true;
        return;
      }
      this.executeRetroactiveBillingWithFilter();
      return;
    }
    if (await this.checkHasPushOrderPendences()) {
      this.showModalPushOrderPendence = true;
      return;
    }
    this.executeRetroactiveBilling();
  }

  async checkHasPushOrderPendencesWithFilter(filter: ContractFilter): Promise<boolean> {
    const pagination: Pagination = new Pagination({
      page: 0,
      itemsPerPage: 100,
      sortBy: [],
      defaultSort: 'customer.name|asc',
    });
    const newFilter = new ContractFilter({
      ...filter,
      status: 'PUSH_ORDER_REQUIRED_BUT_ABSENT',
    });
    const content: any = [];
    await ContractService.filter(
      pagination,
      this.businessUnitId,
      newFilter,
    ).then((response: any) => {
      content.push(...response.content);
      this.pushOrderPendence = content.length;
    });
    return content.length > 0;
  }

  async checkHasPushOrderPendences(): Promise<boolean> {
    const pagination: Pagination = new Pagination({
      page: 0,
      itemsPerPage: 100,
      sortBy: [],
      defaultSort: 'customer.name|asc',
    });
    const filter: ContractFilter = ContractFilter.of({});
    filter.status = 'PUSH_ORDER_REQUIRED_BUT_ABSENT';
    const content: any = [];
    await ContractService.filter(pagination, this.businessUnitId, filter).then((response: any) => {
      content.push(...response.content);
      this.pushOrderPendence = content.length;
    });
    return content.length > 0;
  }

  executeBillingWithFilter(contractsFilter: ContractFilter): void {
    const billingContractsSelected = BillingContractsSelected.of({
      businessUnitId: this.businessUnitId,
      competence: this.filterContractByCompetence(),
      contractFilter: contractsFilter,
      invoiceCompetence: this.invoiceCompetence,
    });

    BillingService.executeBillingSelectedItems(billingContractsSelected)
      .then((taskId: string) => this.handleExecuteBilling(taskId))
      .catch(this.handleError);
  }

  executeRetroactiveBillingWithFilter() {
    const billingContractsSelected = BillingContractsSelected.of({
      businessUnitId: this.businessUnitId,
      competence: this.filterContractByCompetence(),
      contractFilter: this.contractsFilter,
      invoiceCompetence: this.invoiceCompetence,
    });
    BillingService.executeRetroactiveBillingSelectedItems(
      billingContractsSelected,
      this.competences,
      this.startDate,
      this.endDate,
    ).then((taskId: string) => this.handleExecuteBilling(taskId))
      .catch(this.handleError)
  }

  executeRetroactiveBilling() {
    BillingService.executeRetroactiveBilling(
      this.businessUnitId,
      this.invoiceCompetence,
      this.competences,
      this.startDate,
      this.endDate,
    )
      .then((taskId: string) => this.handleExecuteBilling(taskId))
      .catch(this.handleError)
  }

  executeBilling() {
    BillingService.executeBilling({
      businessUnitId: this.businessUnitId,
      invoiceCompetence: this.invoiceCompetence,
      billingDaily: false,
    })
      .then((taskId: string) => this.handleExecuteBilling(taskId))
      .catch(this.handleError);
  }

  handleExecuteBilling(taskId: string) {
    TaskService.getTask(taskId, 10000)
      .then(() => this.handleExecutionSuccess())
      .catch((err) => this.handleError(err));
  }

  handleExecutionSuccess() {
    this.modalState = false;
    this.filterContractByCompetence();
  }

  handleError(err: any) {
    this.stopLoading();
    VbSnackbarService.handleHttpError(err);
    this.$emit('executionError')
  }

  updateDataBillingsFilter(): void {
    this.onlyFiltered = !this.onlyFiltered;
    this.onlyFilteredModal = this.onlyFiltered;
    this.$emit('handleUpdateContractOnlyFiltered');
  }

  closeSuccessModal(): void {
    this.onlyFilteredModal = false;
  }

  closeModal(stopLoad: boolean): void {
    this.showModalPushOrderPendence = false;
    if (stopLoad) this.stopLoading();
  }

  get options(): ModalOptions {
    return {
      title: '',
      description:
        'Ao Selecionar e Executar, serão faturados apenas os contratos dessa Unidade e Competência'
        + ' adicionando apenas os contratos Filtrados na tela',
      titleAlign: 'center',
      showClose: false,
      showOk: true,
    };
  }

  changeBillingType(value: string) {
    this.billingType = value;
  }

  get isSingle() {
    return this.billingType === BillingType.SINGLE;
  }

  closeDialog(): void {
    this.modalState = false;
  }

  updateCompetences(competences: string[]): void {
    this.competences = competences;
  }

  updateStartDate(startDate: string): void {
    this.startDate = startDate;
  }

  updateEndDate(endDate: string): void {
    this.endDate = endDate;
  }

  updateInvoiceCompetence(invoiceCompetence: string): void {
    this.invoiceCompetence = invoiceCompetence;
  }
}
